/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Treatment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Name from './Name/index'
import PrimaryPayers from './PrimaryPayers/index'
import React from 'react'
import SecondaryPayers from './SecondaryPayers/index'
import TotalPayers from './TotalPayers/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Treatment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/Treatment"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Treatment.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-2i9IjI': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<TotalPayers
  viewPath={`${viewPath}/TotalPayers`}
/>
<PrimaryPayers
  viewPath={`${viewPath}/PrimaryPayers`}
/>
<SecondaryPayers
  viewPath={`${viewPath}/SecondaryPayers`}
/>
</div>
{children}
</React.Fragment>)
}